__turbopack_context__.v({
  "buttons": "oLQtKG_buttons",
  "container": "oLQtKG_container",
  "noSideNavVisible": "oLQtKG_noSideNavVisible",
  "supplemental": "oLQtKG_supplemental",
});
